import React, { useEffect } from 'react';
import { AlertComponentPropsWithStyle } from 'react-alert';
import { ColorType, EMIcon, IconType } from '../icon/EMIcon';
export interface ISmartAlertContentProp {
  text: string;
  icon?: IconType;
  color?: ColorType;
  inactiveIcon?: boolean;
  onUndoClick?: () => void;
  onClosed?: () => void;
}
export const SmartAlertContent = (props: ISmartAlertContentProp): React.FunctionComponentElement<ISmartAlertContentProp> => {
  const { text, onUndoClick, icon: iconClass, color, inactiveIcon, onClosed } = props;
  useEffect(() => {
    return () => {
      onClosed && onClosed();
    };
  }, [onClosed]);
  return (
    <>
      <EMIcon icon={iconClass ? iconClass : 'sm-check'} color={color} inactive={inactiveIcon} />
      {text}
      {onUndoClick && (
        <a className="undo" onClick={onUndoClick}>
          undo
        </a>
      )}
    </>
  );
};

export const SmartAlertTemplate: React.ComponentType<AlertComponentPropsWithStyle> = ({ style, options, message, close }) => {
  const alertContainerStyle = { ...style };
  return (
    <div className="react-smart-alert-template">
      <div style={alertContainerStyle} className="smart-alert">
        {message}
        <a className="undo" onClick={close}>
          <EMIcon icon={'sm-close'} />
        </a>
      </div>
    </div>
  );
};
